export default {
  en: {
    default: {
      invitePageLinkDescription: 'The provided link allows users to directly access the ticket purchase page.',
      invitePageQrCodeDescription: 'Download the QR code that leads to ticket purchase and place it on your poster.',
      createEmail: 'Create e-mail',
      //LoginContainer
      loginHeader: 'Hey, welcome back!',
      forgotPasswordLogin: 'Forgot password?',
      logIn: 'Log in',
      loginFormEmail: 'Email*',
      loginFormPassword: 'Password*',
      //RecoverPassowrdContainer
      forgotPasswordPageHeader: 'Forgot password',
      changePassword: 'Change Password',
      //Password field labels & errors
      newPassword: 'New Password',
      repeatPassword: 'Repeat password',
      confirmPassword: 'Confirm password',
      passwordLengthErrorMessage: 'Password must contain 5 characters at least',
      passwordsDoNotMatchError: 'Passwords don`t match',
      orderDiscount: 'Promo code discount:',
      giftCardDiscount: 'Gift card amount:',
      promoCodeDiscount: 'Promo code discount:',
      curatedInvitationResponse: 'Your invitation response has been successfully saved',
      //RegisterContainer
      whatIsCoreEventFee: 'What is CoreEvent fee?',
      required: 'This field is required',
      date: 'This field must be date',
      between: 'This field is out of range',
      minLength: 'This field should contain more values',
      maxLength: 'This field should contain less values',
      minDate: 'This field should be after',
      maxDate: 'This field should be before',
      Email: 'This field must be an email',
      httpUrl: 'This field must be http or https url',
      minValue: 'Provided value is too small',
      maxValue: 'Provided value is too big',
      sameAs: 'This field must be the same as some other field',
      notIn: 'Provided value is already taken',
      numeric: 'This field must be a number',
      url: 'This field must a valid url',
      coreEventFeeInvoice: 'CoreEvent ticketing fee',
      coreEventFee: 'CoreEvent fee',
      function: 'Function',
      companyOrganization: 'Name of the company / organization',
      coreEventFeeDescription:
        'The CoreEvent fee covers the cost of selling tickets quickly and securely. The fee, applied to each purchased ticket, includes the costs of support, maintenance of the server system and administrative work. The amount of the fee may vary according to the commercial agreement with the Event Organizer and is non-refundable.',
      registration: 'Registration',
      registerPaymentVerification: 'Purchase and payment verification',
      onlinePaymentWspay: 'Online payment through the WS Pay system',
      choosePaymentMethod: 'Choose a payment method',
      cardPayment: 'Card payment',
      buyATicket: 'Buy a ticket',
      cryptoPayment: 'Crypto payment',
      giftCardPayment: 'Gift card',
      giftCardPaymentDescription: 'Gift card payment',
      giftCardDataTitle: 'Gift card data',
      giftCardCode: 'Gift card code*',
      giftCardAmount: 'Amount (EUR)*',
      giftCardDescription:
        'Enter the card number and the amount you want to spend in this order. In the next step, you will complete the payment if you chose one of the other forms.',
      giftCardAvailability: 'available',
      accountLogin: 'Log in with a user account',
      finishPaymentInNextStep: 'You will finish the payment on the next step',
      emailLogin: 'Login by email',
      googleLogin: 'Google Sign in',
      registerIfNoAccount: 'Don`t have an account? Register ',
      here: 'here',
      register: 'Register',
      signInToContinue: 'sign in to continue',
      termsOfUse: 'terms of use',
      and: 'and',
      conditionsOfSale: 'conditions of sale',
      guest: 'Continue as guest',
      acceptCoreEvent: 'I accept CoreEvent',
      loginDescription:
        'Log in with your user account and keep tickets for all events in one place or just continue as a guest. You can create an account below.',
      registrationFinish: 'Thank you for registering!',
      submitNote: 'Thank you!',
      yourTicketTo: 'Your ticket to',
      registrationDescription:
        'The information you provided has been sent to the organizers. We will send an email to you as soon as possible.',
      addAttendee: 'Add another attendee',
      aplicationsClosed: 'Applications are closed',
      aplicationSuccessful: 'You have successfully registered a person.',
      //Card-header
      hostedBy: 'Hosted by ',
      at: ' at ',
      //Attendee-data
      attendeeDataDescription:
        'Here you can provide information that will be used to create your accreditation at the event.',
      continueToWorkshops: 'Continue to workshops',
      send: 'Send',
      back: 'Back',
      //Ediit-attendee-data
      editSuccess: 'Registration of your data was successful.',
      //UserProfileContainer
      //UserProfileLabels
      //SignUpContainer
      accountSettings: 'Account settings',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      confirmEmail: 'Confirm email',
      password: 'Password',
      save: 'Save',
      understand: 'I understand',
      continue: 'continue',
      signupHeader: 'Start Your Free Trial.',
      //Orders
      paymentUnsuccessful: 'Payment unsuccessful!',
      paymentUnsuccessfulDescription:
        'An error occurred during purchase. Please try again or choose another payment method.',
      paymentUnsuccessfulActionButton: 'Back to payment',
      cancel: 'Cancel',
      //Canceled payment
      paymentDone: 'The payment has already been made',
      paymentCanceled: 'Payment cancelled, you will be redirected back to the registration form',
      //Footer
      termsOfService: 'Terms of service',
      confirmOrder: 'Confirm order',
      termsOfSale: 'Terms of sale',
      youAreNot: 'You are not',
      clickHere: 'Click here',
      subscription1: 'I agree to share my email address with the organizer',
      quickRegisterDescription:
        'Create a password for your new CoreEvent account and enjoy the benefits of faster ticket purchases and easy access to all purchased tickets. We will use the one listed above to create the account email address.',
      address: 'Address',
      quickRegister: 'Create an account quickly and easily.',
      subscription2:
        'for the purpose of receiving notifications about the latest events, offers or any important information related to the events of the mentioned organizer.',
      privacyPolicy: 'Privacy Policy',
      personalDataProtection: 'Protection of personal data',
      //Input Error messages
      yourAccount: 'Your user account',
      cart: 'Cart',
      customerData: 'Customer information',
      ownerData: 'Owner information',
      submitNoteDescription: 'The information you provided has been sent to the organizers.',
      addPromoCode: 'Add promo code',
      inTotal: 'In total',
      remainingTime: 'Remaining time',
      continueShopping: 'Continue shopping',
      singedInAs: 'You are signed in as:',
      viewTheOrder: 'View the order',
      requiredErrorMessage: 'This field is required',
      payingMethod: 'Payment method: Banknotes',
      purchasedIn: 'The ticket was purchased in',
      invoiceNumber: 'Invoice number',
      invoiceDate: 'Invoice date',
      eventDate: 'Event date',
      invoiceIssued: 'Invoice issued',
      getMyTicket: 'Get my tickets',
      order: 'Order',
      paymentDeadline: 'Payment deadline',
      customer: 'Customer',
      inoviceNum: 'Invo. num.',
      unit: 'unit',
      productDescription: 'Product/service description',
      ticketDescription:
        'By purchasing this ticket, the visitor fully accepts all the conditions and rules of conduct of the event venue and organizer, as well as the conditions stated on this ticket. By not complying with the stated conditions and rules, the visitor will be prohibited from entering the event or will be removed from the venue. Once purchased, the ticket cannot be exchanged or refunded except in case of cancellation or change of event date. CoreEvent is not responsible in case of damage, loss or theft of the ticket or its protective data (such as barcode, serial number, security code, etc.) and in these and similar cases no refund or replacement of the ticket is possible. Damaged, stolen, a ticket that is forged and does not have a steak or security information is invalid and the visitor will not be able to enter the event with such a ticket. Buy tickets exclusively at authorised points of sale! After reading the unique code on the ticket, the ticket becomes invalid, and entry is allowed only to the first bearer of that ticket. Any subsequent login attempt with the same code will be disabled. CoreEvent d.o.o. is an intermediary in the sale of tickets and does not organize the events for which it sells tickets, and as such is not responsible for refunds or changes in the event program. If the event is canceled or the date is changed, the refund will be possible only at the point of sale where the ticket was purchased, within one month of the scheduled start of the event. In certain cases, the refund will be provided directly by the organizer, about which customers will be informed in time. You can get more information at www.core-event.co and at the e-mail address support@core-event.co. Any counterfeiting, abuse and illegal resale of CoreEvent tickets is punishable by law and will be reported to the police. It is forbidden to bring weapons, pyrotechnics, bottles, cans and other items that could endanger safety, as well as audio-visual recording equipment, to the shooting site. Loud music can damage your hearing. By coming to the event, the visitor fully assumes all risks such as the risk of loss, theft and damage to their own property and the risk of bodily injury. By coming to the event, the visitor agrees to be audio-visually recorded without restrictions and without the possibility of financial compensation for the use of said recordings.',
      backToEventPage: 'Back to the event page',
      backToZkm: 'Back to',

      //404
      '404': 'Page not found',
      released: 'Released',
      retailCustomer: 'Retail Customer',
      amout: 'amount',
      event: 'Event:',
      pieces: 'pieces',
      base: 'base',
      totalNoTax: 'Total without tax',
      viewAllEvents: 'View all events',
      ticketSoldOut: 'Tickets are sold out.',
      ticketSoldOutDescription: 'Unfortunately, all tickets for this event are sold out.',
      buyATicketZkm: 'Buy a ticket',
      ticketCategoryZkm: 'Ticket category',
      tax: 'tax',
      itemAmount: 'item amount',
      price: 'price',
      transactionAccount: 'Transaction account',
      issuedInTheName: 'Issued in the name and on behalf of the organizer',
      useTerm: 'Terms of use',
      coreEventTeam: 'Your CoreEvent team wishes you a pleasant time!',
      paymentSuccessful: 'Payment successful',
      paymentMethod: 'Method of payment',
      ticketReady:
        'Your ticket has been purchased and is in your profile, and will soon be delivered to your email address. We wish you a pleasant time!',
      operator: 'Operator / Invoice issued',
      notes: 'Notes',
      gdprText: 'Rules for the protection of personal data on the Internet - COREEVENT.',
      contacts: 'Contacts',
      vat: 'VAT',
      marketingConsent:
        'I give my consent to CoreEvent d.o.o. processes my personal data in the above form in accordance with the purpose and intention of the Organizer of the Event for which I purchase the Ticket via Portal`s email address for its marketing purposes and gives its consent for the stated purpose can deny at any time, all in accordance with the General Data Protection Regulation and',

      contractForCustomers: 'General conditions of the contract for customers',
      companyRegistered:
        'The company is registered in the court register of the Commercial Court in Zagreb under number 081377997. The basic capital of the company amounts to 2.800,00 EUR and has been paid in full. Account for regular the company`s business is managed by Privredna banka Zagreb',
      organizerMessage: 'Organizer message',
      organizer: 'Organizer',
      ourAddresses: 'Our addresses',
      exchangeRate: 'Converted at a fixed conversion rate of 1 EUR = 7.53450 HRK',
      organizerSeller: 'Organizer (seller)',
      ticketUnavailable: 'Tickets are currently not available',
      ticketUnavailableDescription:
        'For information on the future availability of tickets, please contact the event organizer.',
      eventCanceled: 'Event canceled',
      eventCanceledDescription:
        'For tickets purchased through the webshop, you will receive an automatic refund.',
      bulledInName:
        'This item is billed in the name and for the account of the event organizer (seller)',
      requiredSeatError:
        'Please select neighboring locations. It is not allowed to leave it blank.',
      yourTicketLocation:
        'You can find your ticket at the bottom of this page. You can print the ticket or or show the ticket via mobile phone at the entrance',
      ticketQuantityError:
        'The amount of tickets made is less than the number of places it connects to! Please increase the amount of the selected ticket or choose a smaller amount of seats.',
      ticketCategory: 'Ticket categories',
      seatSelection: 'Seat selection',
      chooseTickets: 'Choose tickets via the hall plan',
      available: 'Available',
      unavailable: 'Unavailable',
      selected: 'Selected',
      finishOrder: 'FINISH ORDER',
      keksPayDesc: 'The fastest and without fees via the KEKS Pay application!',
      ticketTypeRegular: 'Type',
      subscriptionType: 'Subscription type',
      ticketQuantity: 'Quantity',
      editShoppingCart: 'edit',
      continueShoppingCart: 'Continue',
      confirmShoppingCart: 'Confirm',
      regularSignIn: 'You are not logged in',
      insertPromoCode: 'Enter promo code (optional)',
      subtotalPriceLabel: 'Subtotal:',

      receiptInfo: 'Receipt information',
      privateReceipt: 'Private receipt',
      r1Invoice: 'Company receipt (R1 invoice)',
      legalEntityName: 'Legal entity name*',
      addressLabel: 'Address (street and number)*',
      zipCode: 'ZIP code*',
      city: 'City*',
      country: 'Country*',
      chooseMinimum: 'Choose minimum',
      tickets1: 'tickets',
      tickets2: 'tickets',
      promoCodeDescriptionTitle: 'What is promo code?',
      promoCodeDescriptionPart1:
        'Sellers can give customers a promo code to enter at checkout to get a discount on their purchase. Entering the promo code is optional.',
      promoCodeDescriptionPart2: 'Here you can enter:',
      promoCodeDescriptionPart3: 'Promo code for discount on purchase',
      promoCodeDescriptionPart4: 'Membership card number or subscription number for theaters',
      activate: 'activate',
      requiredFieldsDescription: 'Fields marked with an asterisk are required.',
      annualTicket: 'Annual ticket',
      membership: 'Membership',
      eventPasswordRequired: 'Password required',
      eventPasswordDescription:
        'Presale is currently open with a password only. Tickets will be available for official sale soon.',
      passwordLabel: 'Password',
      loginToContinue: 'Log in to continue shopping',
      backToEvent: 'Back to Event',
      openInExternalBrowser: 'To sign in with Google, please ',
      openInExternalBrowserBold: 'allow this link to open in your default browser.',
      openInBrowser: 'Open in browser',
      loginWithEmail: 'Log in with email',
      continueHere: 'Continue here',
    },
  },
  hr: {
    default: {
      invitePageLinkDescription: 'Pružena poveznica omogućuje korisnicima izravan pristup stranici za kupnju ulaznica.',
      invitePageQrCodeDescription: 'Preuzmite QR kod koji vodi do kupnje ulaznica i postavite ga na svoj plakat.',
      createEmail: 'Kreiraj e-mail',
      finishOrder: 'ZAVRŠI NARUDŽBU',
      keksPayDesc: 'Najbrže i bez naknada putem KEKS Pay aplikacije!',
      selected: 'Odabrano',
      available: 'Dostupno',
      unavailable: 'Nedostupno',
      chooseTickets: 'Izaberi ulaznice putem plana dvorane',
      seatSelection: 'Odabir sjedala',
      contacts: 'Kontakti',
      ticketCategory: 'Kategorije ulaznica',
      ticketCategoryZkm: 'Odaberi mjesta',
      required: 'Ovo polje je obavezno',
      date: 'Ovo polje mora biti datum',
      between: 'Ovo polje je izvan raspona',
      minLength: 'Ovo polje treba sadržavati više znakova',
      maxLength: 'Ovo polje treba sadržavati manje znakova',
      minDate: 'Ovo polje bi trebalo biti nakon',
      maxDate: 'Ovo polje bi trebalo biti prije',
      personalDataProtection: 'Pravila zaštite osobnih podataka',
      Email: 'Molimo obavezno navedite email',
      httpUrl: 'Ovo polje mora biti http ili https url',
      minValue: 'Navedena vrijednost je premala',
      maxValue: 'Navedena vrijednost je prevelika',
      sameAs: 'Ovo polje mora biti isto kao neko drugo polje',
      notIn: 'Navedena vrijednost je već zauzeta',
      numeric: 'Ovo polje mora biti broj',
      url: 'Ovo polje mora imati važeći url',
      ticketQuantityError:
        'Količina napravljenih karata je manja od broja mjesta s kojima se povezuje! Molimo Vas da povećate količinu odabrane karte ili odaberite manju količinu mjesta.',
      requiredSeatError: 'Molimo, odaberite susjedna mjesta. Nije dozvoljeno ostavljanje praznih.',
      companyRegistered:
        'Društvo je upisano u sudski registar Trgovačkog suda u Zagrebu pod brojem 081377997. Temeljni kapital društva iznosi 2.800,00 EUR i uplaćen je u cijelosti. Račun za redovno poslovamnje društva vodi se kod Privredne Banke Zagreb',
      organizerMessage: 'Poruka organizatora',
      organizer: 'Organizator',
      ourAddresses: 'Naše adrese',
      totalNoTax: 'Ukupno bez poreza',
      transactionAccount: 'Transakcijski račun',
      curatedInvitationResponse: 'Vaš odgovor je uspješno spremljen',
      cardPayment: 'Kartično plaćanje',
      paymentMethod: 'Način plaćanja',
      operator: 'Operater / Račun izdao',
      base: 'osnovice',
      eventDate: 'Datum eventa',
      notes: 'Napomene',
      coreEventFee: 'CoreEvent naknada',
      coreEventFeeInvoice: 'CoreEvent naknada za izdavanje ulaznice',
      whatIsCoreEventFee: 'Što je CoreEvent naknada?',
      contractForCustomers: 'Opći uvjeti ugovora za kupce',
      marketingConsent:
        'Dajem svoju privolu da CoreEvent d.o.o. obrađuje moje osobne podatke u gore navedenom obrascu sukladno svrsi i namjeri Organizatora Događaja za koji kupujem Ulaznicu putem Portala te da CoreEvent d.o.o. obrađuje danu email adresu u svoje marketinške svrhe i da svoju privolu u navedenu svrhu mogu svakodobno uskratit, sve sukladno Općoj uredbi o zaštiti podataka te',
      pieces: 'kom',
      coreEventFeeDescription:
        'CoreEvent naknada pokriva troškove brze i sigurne prodaje ulaznica. Naknada, primijenjena na svaku kupljenu ulaznicu, uključuje troškove podrške, održavanja serverskog sustava te administrativnih poslova. Visina naknade može varirati prema komercijalnom dogovoru s Organizatorom događaja i nije povratna.',
      gdprText: 'Pravilima zaštite osobnih podataka na internet stranicama - COREEVENT.',
      itemAmount: 'Iznos stavke',
      customer: 'Kupac',
      tax: 'Porez',
      understand: 'Razumijem',
      price: 'cijena',
      amount: 'Kol.',
      unit: 'jed.',
      ticketUnavailable: 'Ulaznice trenutno nisu dostupne',
      ticketUnavailableDescription:
        'Za informaciju o naknadnoj dostupnosti ulaznica molimo  kontaktirajte organizatora događaja.',
      eventCanceled: 'Događaj je otkazan',
      eventCanceledDescription:
        'Za ulaznice kupljene preko webshopa ostvarit ćete automatski povrat.',
      viewAllEvents: 'Pogledaj sve događaje',
      ticketSoldOut: 'Ulaznice su rasprodane.',
      ticketSoldOutDescription: 'Nažalost, sve ulaznice za ovaj događaj su rasprodane.',
      productDescription: 'Opis proizvoda/usluge',
      inoviceNum: 'R. br.',
      retailCustomer: 'Maloprodajni kupac',
      orderDiscount: 'Promo kod popust:',
      giftCardDiscount: 'Iznos poklon kartice:',
      promoCodeDiscount: 'Promo kod popust:',
      invoiceDate: 'Datum računa',
      invoiceIssued: 'Račun izdao',
      paymentDeadline: 'Rok plaćanja',
      is: 'je',
      backToEventPage: 'Natrag na stranicu događaja',
      backToZkm: 'Natrag na',
      invoiceNumber: 'Račun broj',
      viewTheOrder: 'Pogledaj narudžbu',
      yourTicketTo: 'Tvoja ulaznica za',
      getMyTicket: 'Preuzmi moje ulaznice',
      bulledInName:
        'Ova stavka zaračunata je u ime i za račun organizatora događaja (prodavatelja)',
      paymentSuccessful: 'Uspješna kupnja!',
      ticketDescription:
        'Kupnjom ove ulaznice posjetitelj u potpunosti prihvaća sve uvjete i pravila ponašanja mjesta događanja i organizatora te uvjete navedene na ovoj ulaznici. Nepridržavanjem navedenih uvjeta i pravila posjetitelju će biti zabranjen ulazak na događaj odnosno bit će udaljen s mjesta događanja. Nakon kupnje, ulaznicu nije moguće zamijeniti niti vratiti osim u slučaju otkazivanja ili promjene datuma događaja. CoreEvent ne snosi odgovornost u slučaju oštećenja, gubitka ili krađe ulaznice ili njenih zaštitnih podataka (poput barkoda, serijskog broja, zaštitnog koda i sl.) te u tim i sličnim slučajevima povrat novca niti zamjena ulaznice nije moguća. Oštećena, ukradena, krivotvorena te ulaznica bez odreska ili zaštitnih podataka je nevažeća i s takvom ulaznicom posjetitelj neće moći ući na događaj. Ulaznice kupuj isključivo na ovlaštenim prodajnim mjestima! Nakon očitanja jedinstvenog koda na ulaznici, ulaznica postaje nevažeća, a ulaz dopušten samo prvom donosiocu te ulaznice. Svaki sljedeći pokušaj ulaska istim kodom bit će onemogućen. CoreEvent d.o.o. je posrednik u prodaji ulaznica i ne organizira događaje za koje prodaje ulaznice te kao takav ne snosi odgovornost za povrat novca niti izmjene u programu događaja. Ako dođe do otkazivanja događaja ili promjene datuma održavanja, povrat novca će biti moguć isključivo na prodajnom mjestu na kojem je ulaznica kupljena i to u roku od mjesec dana od planiranog početka događaja. U određenim slučajima, povrat novca će biti osiguran direktno od organizatora o čemu će kupci biti na vrijeme obaviješteni. Višeinformacija možeš dobiti na www.core-event.co te na e-mail adresi support@core-event.co. Svako krivotvorenje, zloupotreba i ilegalna preprodaja CoreEvent ulaznica je kažnjiva zakonom i bit će prijavljena policiji. Namjesto događanja zabranjeno je unositi oružje, pirotehnička sredstva, boce, limenke i ostale predmete koji mogu ugroziti sigurnost te opremu za audiovizualno snimanje. Glasn glazba može oštetiti tvoj sluh. Dolaskom na događaj, posjetitelj u potpunosti preuzima sve rizike poput rizika od gubitka, krađe i oštećenja vlastite imovine te rizika od tjelesnih ozljeda. Dolaskom na događaj posjetitelj pristaje biti audiovizualno snimljen bez ograničenja i bez mogućnosti financijske kompenzacije za upotrebu navedenih snimki.',
      ticketReady:
        'Tvoja je ulaznica kupljena i nalazi se u tvojem profilu, a uskoro će biti dostavljena i na tvoju email adresu. Želimo ti ugodan provod!',
      issuedInTheName: 'U ime i za račun organizatora izdao',
      released: 'Izdano',
      isNot: 'nije',
      purchasedIn: 'Ulaznica je kupljena u',
      function: 'Funkcija',
      companyOrganization: 'Ime tvrtke / organizacije',
      vat: 'OIB',
      organizerSeller: 'Organizator (prodavatelj)',
      order: 'Narudžba',
      payingMethod: 'Način plaćanja: Novčanice',
      event: 'Event',
      exchangeRate: 'Preračunato po fiksnom tečaju konverzije 1 EUR = 7,53450 HRK',
      useTerm: 'Uvjeti korištenja',
      ticketAsReceipt:
        ' u sustavu PDV-a prema čl. 90, st. 1 i 2 Zakona o PDV-u. Ulaznica vrijedi kao račun.',
      coreEventTeam: 'Ugodan provod želi ti tvoj CoreEvent tim!',
      yourTicketLocation:
        'Svoju ulaznicu možeš pronaći na dnu ove stranice. Ulaznicu možeš isprintati ili je na svom mobilnom telefonu pokazati na ulazu.',
      loginHeader: 'Hej, dobrodošao nazad!',
      forgotPasswordLogin: 'Zaboravljena lozinka?',
      singedInAs: 'Prijavljen si kao:',
      clickHere: 'Klikni ovdje',
      submitNote: 'Hvala!',
      submitNoteDescription: 'Informacije koje ste dali poslane su organizatorima.',
      address: 'Adresa',
      remainingTime: 'Preostalo vrijeme',
      inTotal: 'Ukupno',
      logIn: 'Prijavi se',
      buyATicket: 'Kupi ulaznice',
      buyATicketZkm: 'Kupi ulaznice',
      continueShopping: 'Nastavi s kupnjom',
      addPromoCode: 'Dodaj promo kod',
      cart: 'Košarica',
      ticketType: 'Vrste ulaznice',
      subscriptionType: 'Vrsta pretplate',
      ticketTypeRegular: 'Vrsta',
      ticketQuantity: 'Količina',
      cancel: 'Odustani',
      youAreNot: 'Ti nisi',
      customerData: 'Podaci o kupcu',
      ownerData: 'Podaci vlasnika',
      confirmOrder: 'Potvrdi narudžbu',
      and: 'i',
      yourAccount: 'Tvoj korisnički račun',
      zkmSignIn: 'Nisi prijavljen(a)',
      regularSignIn: 'Nisi prijavljen(a)',
      loginFormEmail: 'Email*',
      loginFormPassword: 'Lozinka*',
      accountLogin: 'Prijavi se s korisničkim računom',
      conditionsOfSale: 'uvjete prodaje',
      quickRegister: 'Brzo i jednostavno izradi račun.',
      quickRegisterDescription:
        'Izradi lozinku za svoj novi CoreEvent račun i uživaj u pogodnostima brže kupnje ulaznica i jednostavnog pristupa svim kupljenim ulaznicama. Za izradu računa koristit ćemo gore navedenu email adresu.',
      subscription1: 'Slažem se da se moja adresa e-pošte podijeli s organizatorom ',
      subscription2:
        ' u svrhu primanja obavijesti o najnovijim događajima, ponudama ili bilo kojim važnim informacijama vezanih uz događaje spomenutog organizatora.',
      termsOfUse: 'uvjete korištenja',
      emailLogin: 'Prijava emailom',
      registerIfNoAccount: 'Nemaš račun? Registriraj se ',
      here: 'ovdje',
      register: 'Registriraj se',
      signInToContinue: 'ulogiraj se kako bi nastavio',
      googleLogin: 'Google prijava',
      acceptCoreEvent: 'Prihvaćam CoreEvent',
      guest: 'Nastavi kao gost',
      guestZkm: 'Podaci o kupcu',
      loginDescription:
        'Prijavi se sa svojim korisničkim računom i na jednom mjestu čuvaj ulaznice za sve događaje ili samo nastavi kao gost. Možeš izraditi račun niže.',
      forgotPasswordPageHeader: 'Zaboravljena lozinka',
      cryptoPayment: 'Plaćanje kriptovalutama',
      giftCardPayment: 'Poklon kartica',
      giftCardPaymentDescription: 'Plaćanje poklon karticom',
      giftCardDataTitle: 'Podaci poklon kartice',
      giftCardCode: 'Kod poklon kartice*',
      giftCardAmount: 'Iznos (EUR)*',
      giftCardDescription:
        'Unesi broj kartice i iznos kojeg želiš potrošiti u ovoj narudžbi. U idućem koraku ćeš dovršiti plaćanje ako si odabrao još neki od ostalih oblika.',
      giftCardAvailability: 'dostupno',
      finishPaymentInNextStep: 'Plaćanje ćeš završiti na sljedećem koraku',
      onlinePaymentWspay: 'Online plaćanje putem WS Pay sustava',
      changePassword: 'Promjeni lozinku',
      choosePaymentMethod: 'Odaberi način plaćanja',
      newPassword: 'Nova lozinka',
      repeatPassword: 'Ponovi lozinku',
      confirmPassword: 'Potvrdi lozinku',
      passwordLengthErrorMessage: 'Lozinka mora imati najmanje 5 znakova',
      passwordsDoNotMatchError: 'Lozinke se ne podudaraju',

      registration: 'Registracija',
      registerPaymentVerification: 'Provjera kupnje i plaćanja',
      registrationFinish: 'Zahvaljujemo se na registraciji!',
      registrationDescription:
        'Podaci koje ste naveli poslani su organizatorima. Poslat ćemo Vam e-mail u što kraćem roku.',
      addAttendee: 'Dodaj još jednog posjetitelja',
      aplicationsClosed: 'Prijave su zatvorene',
      aplicationSuccessful: 'Uspješno ste registrirali osobu.',

      hostedBy: 'Organizira ',
      at: ' u ',

      attendeeDataDescription:
        'Ovdje možete pružiti informacije koje će se koristiti za izradu vaše akreditacije na događaju.',
      continueToWorkshops: 'Nastavi na radionice',
      send: 'Pošalji',
      back: 'Natrag',

      editSuccess: 'Registracija Vaših podatka je bila uspješna.',
      accountSettings: 'Postavke profila',
      firstName: 'Ime',
      lastName: 'Prezime',
      email: 'Email',
      confirmEmail: 'Potvrdi email',
      password: 'Lozinka',
      save: 'Spremi',
      continue: 'Nastavi',
      signupHeader: 'Registriraj se',

      paymentUnsuccessful: 'Kupnja neuspješna!',
      paymentUnsuccessfulDescription:
        'Dogodila se pogreška prilikom kupnje. Molimo da pokušaš ponovno ili odabereš drugi način plaćanja.',
      paymentUnsuccessfulActionButton: 'Natrag na kupnju',

      paymentDone: 'Uplata je već izvršena',
      paymentCanceled:
        'Uplata je otkazana, bit ćete preusmjereni natrag na obrazac za registraciju',

      termsOfService: 'Uvjeti pružanja usluge',
      termsOfSale: 'Uvjeti prodaje',
      privacyPolicy: 'Politika privatnosti',

      requiredErrorMessage: 'Ovo polje je potrebno',

      '404': 'Stranica nije pronađena',
      editShoppingCart: 'uredi',
      continueShoppingCart: 'Nastavi',
      confirmShoppingCart: 'Potvrdi',
      insertPromoCode: 'Unesite promo kod (neobavezno)',
      subtotalPriceLabel: 'Međuzbroj:',

      receiptInfo: 'Podaci za račun',
      privateReceipt: 'Privatni račun',
      r1Invoice: 'Račun na ime tvrtke (R1)',
      legalEntityName: 'Naziv pravne osobe*',
      addressLabel: 'Adresa (ulica i kućni broj)*',
      zipCode: 'Poštanski broj*',
      city: 'Grad*',
      country: 'Država*',
      chooseMinimum: 'Odaberi minimalno',
      tickets1: 'ulaznica',
      tickets2: 'ulaznice',
      promoCodeDescriptionTitle: 'Što je promo kod?',
      promoCodeDescriptionPart1:
        'Prodavatelji mogu dati kupcima promo kod koji se unosi prilikom plaćanja kako bi ostvarili popust za svoju kupnju. Unos promo koda nije obavezan.',
      promoCodeDescriptionPart2: 'Ovdje se može unijeti:',
      promoCodeDescriptionPart3: 'Promo kod za popust pri kupnji',
      promoCodeDescriptionPart4: 'Broj članske kartice ili preplatnički broj za kazališta',
      activate: 'aktiviraj',
      requiredFieldsDescription: 'Obvezna su polja označena zvjezdicom.',
      annualTicket: 'Godišnja ulaznica',
      membership: 'Članstvo',
      eventPasswordRequired: 'Potrebna lozinka',
      eventPasswordDescription:
        'Pretprodaja je trenutno moguća putem passworda. Ulaznice će uskoro biti dostupne u slobodnoj prodaji.',
      passwordLabel: 'Lozinka',
      loginToContinue: 'Prijavi se u sustav kako bi nastavio/la s kupnjom',
      backToEvent: 'Natrag na događaj',
      openInExternalBrowser: 'Za prijavu putem Googlea ',
      openInExternalBrowserBold: 'dopustite otvaranje ovog linka u vašem zadanom pregledniku.',
      openInBrowser: 'Otvori u pregledniku',
      loginWithEmail: 'Za prijavu putem maila',
      continueHere: 'Nastavi ovdje',
    },
  },
}
